import { SVGComponent } from '@/types/types';
import { useState } from 'react';

export interface Props {
  type: string;
  Icon?: SVGComponent;
  currentTab: string;
  setCurrentTab: (value: string) => void;
}

export function ButtonAdminTab({ type, Icon, currentTab, setCurrentTab }: Props) {
  //FIELDS
  const [isMouseOver, setIsMouseOver] = useState(false);

  /*
   * EVENTS
   */

  function onClick() {
    if (currentTab == type) return;

    setCurrentTab(type);
  }

  /*
   * RENDERS
   */

  function render_icon() {
    let out = <></>;

    if (Icon) {
      out = <Icon className={`!w-5 !h-5 hover-animation-important ${currentTab == type || isMouseOver ? '!text-bar' : '!text-component-item-foreground'}`} />;
    }

    return out;
  }

  /*
   * HTML
   */
  return (
    <>
      <div
        className={`list-item-wrapper hover-animation gap-5
        ${currentTab == type || isMouseOver ? 'list-item-selected ' : ''}`}
        onClick={onClick}
        onMouseEnter={() => setIsMouseOver(true)}
        onMouseLeave={() => setIsMouseOver(false)}
      >
        {render_icon()}
        <div className="list-item-inner">
          <p className={`text-left m-0`}>{type}</p>
        </div>
      </div>
    </>
  );
}
